<template>
  <Loading v-bind:show="showLoading">
    <center>
      <md-button type="button" class="md-raised md-accent" @click="fechar">Fechar</md-button>
    </center>
  </Loading>
</template>

<script>
  import Loading from '@/components/Loading';
  import PerfilAluno from '@/services/PerfilAlunoService.js';

  export default {
    name: 'Home',
    data() {
      return {
        showLoading: true
      }
    },
    components: {
      Loading
    },
    created() {
      this.perfilAlunoService = new PerfilAluno(this);

      let token = this.$route.query.token;
      if (token) {
        this.carregar(token);
      }
      else {
        this.$modal.alert("Para acessar o Integra, escolha um aluno na página <a href='" + this.$Configs.urlServiceNow + "pad?id=pda_master'>Pesquisar aluno</a> no PAD.",
          "",
          () => { window.location = this.$Configs.urlServiceNow });

        this.showLoading = false;
      }
    },
    methods: {
      fechar() {
        window.close();
      },

      carregar(token) {

        this.perfilAlunoService.RetornaDadosAluno({ token }).then(
          data => {
            if (data.ok && data.dados) {
              var aluno = {};
              var redirectRaid = (data.dados.sistema && data.dados.sistema == "COLABORAR");

              aluno.PerfilAluno = data.dados;

              sessionStorage.Aluno = JSON.stringify(aluno);
              sessionStorage.AlunoToken = token;

              if (redirectRaid) {
                this.$router.push('raid');
              } else {
                this.$router.push('aluno');
              }
            }
            else {
              this.showLoading = false;
              this.$modal.info(data.mensagem);
            }
          },
          error => {
            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);

          }).finally(() => {
            this.showLoading = false;
          });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
